import { Component, OnInit, OnChanges, Input } from '@angular/core';
declare var $;

@Component({
  selector: 'si-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnChanges {
  @Input() toastId: string;
  @Input() icon: object;
  @Input() content: string;
  constructor() { }

  ngOnChanges() {
    if (this.toastId !== undefined) {
      $('#' + this.toastId).toast('show');
    }
  }

  ngOnInit() { }

  closeToast() {
    $(`#${this.toastId}`).toast('hide');
  }
}
